// Hoops Contracts Configuration
// V2 deployed to Stellar Testnet: February 18, 2026

export const HOOPS_NETWORK = "TESTNET";
export const HOOPS_NETWORK_PASSPHRASE = "Test SDF Network ; September 2015";
export const HOOPS_RPC_URL = "https://soroban-testnet.stellar.org";

// Adapter IDs - must match contract definitions
export const ADAPTER_IDS = {
  AQUA: 0,
  COMET: 1,
  PHOENIX: 2,
  SOROSWAP: 3,
} as const;

// Account Contract V3 WASM Hash (uploaded to testnet — passkey + session keys + pool discovery)
export const ACCOUNT_WASM_HASH = process.env.NEXT_PUBLIC_ACCOUNT_WASM_HASH
  || "58e2cbac21100ec2b0c3e7ef0467fd4115d9fdf0cd1b520959702af65dd079e2";

// V2 Deployed Contract Addresses on Testnet (from env or defaults)
export const HOOPS_CONTRACTS = {
  // Core Contracts
  ROUTER: process.env.NEXT_PUBLIC_ROUTER || "CCZRK7KHEEBD6RNN2IRCHRKE24REGFFBGKKLQWTC4UZJAMWTALFKGG7A",
  ACCOUNT_DEPLOYER: process.env.NEXT_PUBLIC_ACCOUNT_DEPLOYER || "CDBKXYD3HHYUSHPRVTGDQRVAHRVDRLIUWER2KZRIAHYLPSOARXEX54Z6",

  // Protocol Adapters (V2: remove_liq_from_pool + direct deposit)
  ADAPTERS: {
    AQUA: process.env.NEXT_PUBLIC_AQUA_ADAPTER || "CCRNYSWOFHBMWR332WNSIXYXR66D77QN3PKEOGIZIPQNS2JXHLNJKTKF",
    COMET: process.env.NEXT_PUBLIC_COMET_ADAPTER || "CD5V7E7HTH6LGGYASQPRFPEECLU6J3FG6SKM3V6IFRYY46PMJK3XVE3N",
    PHOENIX: process.env.NEXT_PUBLIC_PHOENIX_ADAPTER || "CD5CCAA5OGLKYZGHWWIA4I2KZ4Q6GXHNFFZFCIBDTQNWVG6CVPEAISYV",
    SOROSWAP: process.env.NEXT_PUBLIC_SOROSWAP_ADAPTER || "CAG345I4ZHLGZCAWCRF3WWEDGT2TYN6Y6FHXKMTVQC6W2VARZNEIXJNZ",
  },
};

// Testnet Token Addresses (from env or defaults)
export const TESTNET_TOKENS = {
  USDC: process.env.NEXT_PUBLIC_USDC_TOKEN || "CCK7SHQU5ZTHXO2XSCS3M7T5O757JPSBY7A6ENMXV3OI7V6RKANGUEP2",
  XLM: process.env.NEXT_PUBLIC_XLM_SAC || "CDLZFC3SYJYDZT7K67VZ75HPJVIEUVNIXF47ZG2FB2RMQQVU2HHGCYSC",
};

// Pool addresses for swap routing (Soroswap pair used as default swap pool)
export const POOL_ADDRESSES = {
  SOROSWAP_PAIR: process.env.NEXT_PUBLIC_SOROSWAP_PAIR || "CA5N67HUBNIZWQZYBSAWQ7L7WO2OPD3ZD4OSXSUAP63OMBDMSH3PUHN7",
  AQUA_POOL: process.env.NEXT_PUBLIC_AQUA_POOL || "CDGT6WSK5CD2BLYIRFXK6SD2NEPP4ZVQI6VWFQHWWAOM2QQUK24XKFI4",
  AQUA_LP_TOKEN: process.env.NEXT_PUBLIC_AQUA_LP_TOKEN || "CAMWRVTCOOSS6EFBZURBGUB3CNU4PZ2JDPC25VOA2O66ELPIN6I5G6IH",
  PHOENIX_POOL: process.env.NEXT_PUBLIC_PHOENIX_POOL || "CCZBWDTPPSAUL6BP5SA7GISBF4236NNGWFV3KIFIBE5BD7TCEEUCAOES",
  PHOENIX_LP_TOKEN: process.env.NEXT_PUBLIC_PHOENIX_LP_TOKEN || "CCIWZSWQHYU36EJDNHLAOOT3OQS7SLKOVHZYBRGE6JIHF55Y74LRR6E7",
  COMET_POOL: process.env.NEXT_PUBLIC_COMET_POOL || "CDEKGYLT2UWAO2SO3WKW5QC3F7G23L3AU3XPPOMAPGAFN7GKYVXZVMDD",
};

// External AMM routers/factories (for market discovery)
export const EXTERNAL_AMMS = {
  SOROSWAP_FACTORY: process.env.NEXT_PUBLIC_SOROSWAP_FACTORY || "CDX3HAQSRKITXPAYA46DSAMDEQ5C5DZZXMNOMY64HCKDDZLHM2G7G52X",
};

// Token decimals
export const TOKEN_DECIMALS = 7; // Both USDC and XLM use 7 decimals on Soroban
export const TOKEN_UNIT = 10_000_000; // 10^7

// Protocol Names for Display
export const ADAPTER_NAMES: Record<number, string> = {
  [ADAPTER_IDS.AQUA]: "Aquarius",
  [ADAPTER_IDS.COMET]: "Comet",
  [ADAPTER_IDS.PHOENIX]: "Phoenix",
  [ADAPTER_IDS.SOROSWAP]: "Soroswap",
};

// Helper to get Stellar Expert contract URL
export function getContractExplorerUrl(contractId: string): string {
  return `https://stellar.expert/explorer/testnet/contract/${contractId}`;
}

// Helper to get Stellar Expert transaction URL
export function getTxExplorerUrl(txHash: string): string {
  return `https://stellar.expert/explorer/testnet/tx/${txHash}`;
}
